import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "8f25662f-ba6b-4921-8018-f4fe0ce41e95", content: "Interaural level difference", options: {} },
  { id: "2932ea20-4e68-438b-9322-42409560d209", content: "Monaural cue", options: {} },
  { id: "f3f2687a-b1be-4514-9fee-67b443538763", content: "Interaural time difference", options: {} },
  { id: "6d1c1031-9c38-4310-bc81-321975819aa3", content: "Interaural axis adjustment", options: {} },
];

export const task: Task = {
  id: "6fcace0a-8771-47bd-8d32-5875948e8415",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["f3f2687a-b1be-4514-9fee-67b443538763"],
};
